import React from 'react';
import ExternalLanding from "./ExternalLanding";
import PageSEO from "../components/seo/PageSEO";
import useHubSpotUTMQueryParams from "../hooks/useHubSpotUTMQueryParams";
import {externalLinks} from "../requests/external-endpoints";

export const Contact = () => {
  const searchParams = useHubSpotUTMQueryParams();
  const constructedUrl = `${externalLinks.contact}?${searchParams.toString()}`;
  return <>
    <PageSEO
      title="Contact SecurSpace | Truck Parking & Storage"
      description="Questions about truck parking, container storage or listing your yard? Get in touch with the SecurSpace team."
      canonicalUrl="https://secur.space/contact"
    />
    <ExternalLanding url={constructedUrl} />
  </>;
}

export default Contact;
